import React from 'react'
import {FormattedMessage} from 'react-intl'
import R from 'ramda'

import Icon from './Icon'
import Drawer from './Drawer'
import ServicesSuggestions from './ServicesSuggestions'
import RowOfSepararedChildren from './RowOfSepararedChildren'
import StatelessFuncToPureComponent from './StatelessFuncToPureComponent'


const Suggestions = ({suggestions, show, forceSuggestions, onToggleSuggestions, onSelectSuggestion}) => {
  
  const nbSuggestions = R.length(suggestions) || 1
  const half = Math.ceil(nbSuggestions/2)
  //const splittedSuggestions = R.splitEvery(half, suggestions)

  // The suggestions are not splitted into columns.
  const splittedSuggestions = R.splitEvery(nbSuggestions, suggestions) 

  return <Drawer className="suggestions" open={show.suggestions} forced={forceSuggestions} onToggle={onToggleSuggestions}>
    <FormattedMessage id="Our suggestions" defaultMessage="Our suggestions"/>
    <RowOfSepararedChildren>
      {splittedSuggestions.map((suggestions, index) =>
        <ServicesSuggestions key={index} options={suggestions} onSelect={onSelectSuggestion}/>
      )}
    </RowOfSepararedChildren>
  </Drawer>
}

Suggestions.propTypes = {
  show: React.PropTypes.shape({
    suggestions: React.PropTypes.bool.isRequired
  }),
  suggestions: React.PropTypes.array.isRequired,
  forceSuggestions: React.PropTypes.bool,
  onToggleSuggestions: React.PropTypes.func.isRequired,
  onSelectSuggestion: React.PropTypes.func.isRequired
}

export default StatelessFuncToPureComponent(Suggestions)



/** WEBPACK FOOTER **
 ** ./app/components/Suggestions.jsx
 **/